module.exports = "/img/audi.1db95fc1.png";